const lng = {
    "copyright": {
        "fa": "Copyright 2024 © Negin Rayaneh",
        "en": "Copyright 2024 © Negin Rayaneh"
    },
    "build_no": {
        "fa": "--loads at run time--",
        "en": "--loads at run time--"
    },
    ",": {
        "fa": "، ",
        "en": ", "
    },
    "farsi": {
        "fa": "فارسی",
        "en": "Persian"
    },
    "english": {
        "fa": "انگلیسی",
        "en": "English"
    },
    "operations": {
        "fa": "عملیات",
        "en": "Operations"
    },
    "impression": {
        "fa": "نتیجه نهایی",
        "en": "Impression"
    },
    "all": {
        "fa": "همه",
        "en": "All"
    },
    "last_name": {
        "fa": "نام خانوادگی",
        "en": "Last name"
    },
    "full_name": {
        "fa": "نام",
        "en": "Name"
    },
    "report_status_sent_to_his": {
        "fa": "ارسال به اچ‌آی‌اس",
        "en": "Sent to HIS"
    },
    "report_status_sent_to_patient": {
        "fa": "ارسال به بیمار",
        "en": "Sent to Patient"
    },
    "start_with": {
        "fa": "شروع با",
        "en": "Start with"
    },
    "his_multiple_request_found": {
        "fa": "برای شماره درخواست '{request_number}' بیش از یک رکورد ({records_count} عدد) رکورد ثبت شده",
        "en": "Multiple records ({records_count} records) found for request ID '{request_number}'"
    },
    "error_sending_report_to_his": {
        "fa": "خطا در ارسال گزارش به HIS",
        "en": "Error sending report to HIS"
    },
    "similarity": {
        "fa": "نوع شباهت",
        "en": "Similarity type"
    },
    "save_and_continue": {
        "fa": "ذخیره و ادامه",
        "en": "Save and Continue"
    },
    "update_template": {
        "fa": "به روز رسانی الگو",
        "en": "Update Template"
    },
    "his_first_name": {
        "fa": "نام فارسی",
        "en": "HIS first name"
    },
    "show_report": {
        "fa": "نمایش گزارش",
        "en": "Show report"
    },
    "report_status": {
        "fa": "وضعیت گزارش",
        "en": "Report Status"
    },
    "report_statuses": {
        "fa": "انواع وضعیت گزارش",
        "en": "Report Statuses"
    },
    "expressions": {
        "fa": "عبارات",
        "en": "Expressions"
    },
    "from_yesterday": {
        "fa": "از دیروز",
        "en": "From yesyerday"
    },
    "measure_circle": {
        "fa": "اندازه‌گیری دایره",
        "en": "Measure Circle"
    },
    "pause": {
        "fa": "توقف",
        "en": "Pause"
    },
    "ok": {
        "fa": "تایید",
        "en": "OK"
    },
    "client_is_not_verified": {
        "fa": "اجرای نرم‌افزار بر روی این سیستم مجاز نیست. با پشتیبان تماس بگیرید",
        "en": "Client '{client.name}' is not verified. Contact support"
    },
    "single_date": {
        "fa": "روز مشخص",
        "en": "Single date"
    },
    "Solar Hejri": {
        "fa": "هجری شمسی",
        "en": "Solar Hejri"
    },
    "show_image_report": {
        "fa": "نمایش گزارش/تصویر",
        "en": "Show Report/Image"
    },
    "report_info": {
        "fa": "اطلاعات گزارش",
        "en": "Report information"
    },
    "shortcut": {
        "fa": "میانبر",
        "en": "Shortcut"
    },
    "patient_name": {
        "fa": "نام بیمار",
        "en": "Patient Name"
    },
    "welcome_": {
        "fa": "خوش آمدید {name}",
        "en": "Welcome {name}"
    },
    "system_maintenance_will_expire": {
        "fa": "سیستم از تاریخ <span dir='ltr'>{expiration}</span> فاقد پشتیبانی خواهد بود",
        "en": "System maintenance will expire on {expiration}"
    },
    "save": {
        "fa": "ذخیره",
        "en": "Save"
    },
    "study_date": {
        "fa": "تاریخ مراجعه",
        "en": "Study Date"
    },
    "watch_point_values": {
        "fa": "مشاهده مقادیر نقاط",
        "en": "Watch point values"
    },
    "report_title_full_list": {
        "fa": "لیست کامل",
        "en": "Full list"
    },
    "show_texts": {
        "fa": "نمایش اطلاعات",
        "en": "Show Texts"
    },
    "save_and_next": {
        "fa": "ذخیره و بعدی",
        "en": "Save and Next"
    },
    "study_description": {
        "fa": "توضیحات مراجعه",
        "en": "Study description"
    },
    "date_range": {
        "fa": "بازه تاریخی",
        "en": "Date range"
    },
    "report": {
        "fa": "گزارش",
        "en": "Report"
    },
    "password": {
        "fa": "رمز ورود",
        "en": "Password"
    },
    "confirm_password": {
        "fa": "تایید رمز",
        "en": "Confirm Password"
    },
    "change_password": {
        "fa": "تغییر رمز",
        "en": "Change Password"
    },
    "password_changed": {
        "fa": "رمز ورود تغییر پیدا کرد",
        "en": "Password was changed"
    },
    "password_confirm_not_match": {
        "fa": "رمز و تایید رمز یکسان نیستند",
        "en": "Password doesn't match with confirm"
    },
    "exact": {
        "fa": "دقیقا مساوی",
        "en": "Exactly"
    },
    "like": {
        "fa": "شبیه",
        "en": "Like"
    },
    "study_has_no_report": {
        "fa": "برای این مراجعه گزارشی ثبت نشده است",
        "en": "Study contains no report"
    },
    "name": {
        "fa": "نام",
        "en": "Name"
    },
    "search_clear": {
        "fa": "نمایش همه",
        "en": "Show all"
    },
    "settings": {
        "fa": "تنظیمات",
        "en": "Settings"
    },
    "gender": {
        "fa": "جنسیت",
        "en": "Gender"
    },
    "mobile": {
        "fa": "همراه",
        "en": "Mobile"
    },
    "view_state": {
        "fa": "حالت نمایش",
        "en": "View State"
    },
    "report_text": {
        "fa": "متن گزارش",
        "en": "Report text"
    },
    "request_id": {
        "fa": "شماره درخواست",
        "en": "Request ID"
    },
    "x": {
        "fa": "*",
        "en": "x"
    },
    "windowlevel": {
        "fa": "پنجره نمایش",
        "en": "Window level"
    },
    "view": {
        "fa": "مشاهده",
        "en": "View"
    },
    "templates": {
        "fa": "الگوها",
        "en": "Templates"
    },
    "right": {
        "fa": "راست",
        "en": "Right"
    },
    "latin_last_name": {
        "fa": "نام خانوادگی لاتین",
        "en": "Latin last name"
    },
    "findings": {
        "fa": "یافته‌ها",
        "en": "Findings"
    },
    "profile_err_invalid_or_expired_ticket": {
        "fa": "لاگین منقضی شده است. لطفا دوباره لاگین کنید",
        "en": "Login is expired"
    },
    "profile_err_expired_ticket": {
        "fa": "لطفا دوباره در سیستم لاگین کنید",
        "en": "Login again please"
    },
    "profile_err_terminated_session": {
        "fa": "جلسه کاری خاتمه داده شده است. دوباره لاگین کنید",
        "en": "Current session is terminated. Login again"
    },
    "login_as_another_user": {
        "fa": "لاگین با کاربر دیگر",
        "en": "login as another user"
    },
    "report_status_verified": {
        "fa": "تایید نهایی",
        "en": "Verified"
    },
    "report_status_verified_with_staff": {
        "fa": "تایید نهایی با حضور استاف",
        "en": "Verified with staff"
    },
    "report_status_verified_without_staff": {
        "fa": "تایید نهایی بدون حضور استاف",
        "en": "Verified without staff"
    },
    "report_updated": {
        "fa": "تغییرات گزارش ثبت شد",
        "en": "Report is updated"
    },
    "first_or_last_name": {
        "fa": "نام یا نام خانوادگی",
        "en": "First or Last name"
    },
    "sync": {
        "fa": "همگام",
        "en": "Sync"
    },
    "sex": {
        "fa": "جنسیت",
        "en": "Sex"
    },
    "report_status_undefined": {
        "fa": "جدید",
        "en": "New"
    },
    "his_last_name": {
        "fa": "نام خانوادگی فارسی",
        "en": "HIS last name"
    },
    "his_full_name": {
        "fa": "نام HIS",
        "en": "HIS name"
    },
    "calendar": {
        "fa": "تقویم",
        "en": "Calendar"
    },
    "mega_byte": {
        "fa": "مگابایت",
        "en": "MB"
    },
    "measure_distance": {
        "fa": "اندازه‌گیری فاصله",
        "en": "Measure distance"
    },
    "first_name": {
        "fa": "نام",
        "en": "First name"
    },
    "clearDrawings": {
        "fa": "حذف همه ترسیم‌ها",
        "en": "Clear all drawings"
    },
    "total_size": {
        "fa": "حجم کل",
        "en": "Total size"
    },
    "comments": {
        "fa": "توضیحات",
        "en": "Comments"
    },
    "view_style": {
        "fa": "نحوه نمایش",
        "en": "View Style"
    },
    "save_and_close": {
        "fa": "ذخیره و خروج",
        "en": "Save and Close"
    },
    "close": {
        "fa": "خروج",
        "en": "Close"
    },
    "en": {
        "fa": "انگلیسی",
        "en": "English"
    },
    "print": {
        "fa": "چاپ",
        "en": "Print"
    },
    "staff": {
        "fa": "استاف",
        "en": "Staff"
    },
    "staff_2": {
        "fa": "استاف ۲",
        "en": "Staff 2"
    },
    "delete_series": {
        "fa": "حذف مراجعه",
        "en": "Delete Study"
    },
    "report_status_admitted": {
        "fa": "پذیرش شده",
        "en": "Admitted"
    },
    "report_status_draft": {
        "fa": "پیش نویس",
        "en": "draft"
    },
    "draft": {
        "fa": "پیش نویس",
        "en": "draft"
    },
    "from_last_year": {
        "fa": "از سال گذشته",
        "en": "From last year"
    },
    "description_name": {
        "fa": "عنوان",
        "en": "Title"
    },
    "title": {
        "fa": "عنوان",
        "en": "Title"
    },
    "bold": {
        "fa": "ضخیم",
        "en": "Bold"
    },
    "italic": {
        "fa": "مورب",
        "en": "Italic"
    },
    "headings": {
        "fa": "عناوین",
        "en": "Headings"
    },
    "line": {
        "fa": "خط",
        "en": "Line"
    },
    "unordered_list": {
        "fa": "لیست بدون ترتیب",
        "en": "Unordered list"
    },
    "ordered_list": {
        "fa": "لیست با شماه ترتیب",
        "en": "Ordered list"
    },
    "user_has_been_disabled": {
        "fa": "کاربر غیرفعال شده است",
        "en": "User has been disabled. Contact administrator"
    },
    "Radiologist_2": {
        "fa": "رادیولوژیست ۲",
        "en": "Radiologist 2"
    },
    "Radiologist_1": {
        "fa": "رادیولوژیست ۱",
        "en": "Radiologist 1"
    },
    "delete_study": {
        "fa": "حذف سری",
        "en": "Delete series"
    },
    "client_is_not_allowed_to_operate": {
        "fa": "کلاینت {client.aetitle} مجاز به اجرای {operation} نمی‌باشد",
        "en": "Client {client.aetitle} is not allowed to {operation}"
    },
    "filter_comments_help": {
        "fa": "توضیحات بیمار یا مراجعه یا سری",
        "en": "Patient or Study or series comments"
    },
    "advanced_viewer": {
        "fa": "نمایشگر پیشرفته",
        "en": "Advanced viewer"
    },
    "byte": {
        "fa": "بایت",
        "en": "B"
    },
    "text_direction": {
        "fa": "جهت",
        "en": "Direction"
    },
    "search": {
        "fa": "جستجو",
        "en": "Search"
    },
    "language": {
        "fa": "زبان",
        "en": "Language"
    },
    "dictaphone": {
        "fa": "دیکتافون",
        "en": "Dictaphone"
    },
    "dictaphone_error_only_https": {
        "fa": "قابلیت گزارش صوتی فقط از طریق https قابل استفاده است",
        "en": "Voice report is only available at https address"
    },
    "similar": {
        "fa": "شبیه",
        "en": "Similar"
    },
    "incorrect_study_id": {
        "fa": "شماره ملی یا رمز ورود اشتباه است.",
        "en": "Incorrect national code or password."
    },
    "patient_id": {
        "fa": "کد بیمار",
        "en": "Patient ID"
    },
    "patient_code": {
        "fa": "کد پرونده",
        "en": "Patient Code"
    },
    "accept_time": {
        "fa": "زمان تایید",
        "en": "Accept time"
    },
    "logout": {
        "fa": "خروج",
        "en": "Logout"
    },
    "login": {
        "fa": "ورود",
        "en": "Login"
    },
    "delete": {
        "fa": "حذف",
        "en": "Delete"
    },
    "giga_byte": {
        "fa": "گیگابایت",
        "en": "GB"
    },
    "report_status_no_report": {
        "fa": "فاقد ریپورت",
        "en": "No report"
    },
    "report_status_typed": {
        "fa": "تایپ شده",
        "en": "Typed"
    },
    "report_status_drafted": {
        "fa": "پیش‌نویس",
        "en": "Drafted"
    },
    "report_status_removed": {
        "fa": "حذف شده",
        "en": "Removed"
    },
    "modalities": {
        "fa": "انواع تصاویر",
        "en": "Modalities"
    },
    "chose_modalities": {
        "fa": "انتخاب نوع",
        "en": "Chose Modalities"
    },
    "choose_modality": {
        "fa": "همه انواع",
        "en": "All Modalities"
    },
    "speed_up_already_requested": {
        "fa": "درخواست تسریع گزارش برای این مراجعه قبلا ارسال شده است",
        "en": "Speed up request is already sent for this study"
    },
    "verify_time": {
        "fa": "زمان تایید نهایی",
        "en": "Verify time"
    },
    "referring_physician_and_operators_name": {
        "fa": "پزشک \\ کاربر",
        "en": "Physician \\ Operator"
    },
    "referring_physicians_name": {
        "fa": "پزشک ارجاع دهنده",
        "en": "Referring Physician Name"
    },
    "operators_name": {
        "fa": "کارشناس دستگاه",
        "en": "Operator Name"
    },
    "female": {
        "fa": "زن",
        "en": "Female"
    },
    "type": {
        "fa": "تایپ",
        "en": "Type"
    },
    "operator": {
        "fa": "کارشناس",
        "en": "Operator"
    },
    "from_last_month": {
        "fa": "از ماه پیش",
        "en": "From last month"
    },
    "his_user_is_not_radiologist_in_his": {
        "fa": "با توجه به استعلام از HIS کاربر '{user}' در حال حاضر رادیولوژیست نیست",
        "en": "User '{user}' is not Radiologist according to HIS"
    },
    "update_his_requests": {
        "fa": "به روز رسانی از HIS",
        "en": "Update from HIS"
    },
    "n_requests_added_from_his": {
        "fa": "تعداد {count} درخواست جدید از HIS درج شد",
        "en": "{count} new request(s) added from HIS"
    },
    "no_new_requests_added_from_his": {
        "fa": "درخواستهای HIS به روز است",
        "en": "HIS requests are already up to date"
    },
    "save_expression": {
        "fa": "ذخیره عبارت",
        "en": "Save Expression"
    },
    "from": {
        "fa": "از",
        "en": "From"
    },
    "by": {
        "fa": "توسط",
        "en": "by"
    },
    "referring_physician": {
        "fa": "پزشک ارجاع دهنده",
        "en": "Referring Physician"
    },
    "time": {
        "fa": "زمان",
        "en": "Time"
    },
    "forward": {
        "fa": "انتقال",
        "en": "Forward"
    },
    "new_report": {
        "fa": "گزارش جدید",
        "en": "New report"
    },
    "study_or_birth_or_report_type_or_accept_date": {
        "fa": "تاریخ مراجعه یا تولد یا تایپ یا تایید گزارش",
        "en": "Study or Birthdate or Report type or Accept Date"
    },
    "today": {
        "fa": "امروز",
        "en": "Today"
    },
    "username": {
        "fa": "نام کاربری",
        "en": "Username"
    },
    "direction": {
        "fa": "rtl",
        "en": "ltr"
    },
    "remember_me": {
        "fa": "به خاطر سپاری لاگین من روی این سیستم",
        "en": "Remember me on this computer"
    },
    "remember_me_hint": {
        "fa": "اگر این سیستم شخصی شماست و دیگران از آن استفاده نمی‌کنند می‌توانید این تیک را بزنید",
        "en": "You can check if this is your personal system and no one else is using it"
    },
    "latin_first_name": {
        "fa": "نام لاتین",
        "en": "Latin first name"
    },
    "end_date": {
        "fa": "زمان انتها",
        "en": "End date"
    },
    "login_first": {
        "fa": "شما باید ابتدا در سیستم لاگین کنید",
        "en": "You must first login"
    },
    "outpatient": {
        "fa": "سرپایی",
        "en": "Outpatient"
    },
    "emergency": {
        "fa": "اورژانسی",
        "en": "Emergency"
    },
    "inpatient-and-emergency": {
        "fa": "بستری و اورژانسی",
        "en": "Inpatient and Emergency"
    },
    "histogram": {
        "fa": "هیستوگرام",
        "en": "Histogram"
    },
    "patient_id_or_request_number": {
        "fa": "کد پرونده / شماره ملی / شناسه درخواست",
        "en": "Patient ID / National code / Request ID"
    },
    "report_status_accepted": {
        "fa": "تایید دستیار",
        "en": "Accepted"
    },
    "count": {
        "fa": "تعداد",
        "en": "Count"
    },
    "kilo_byte": {
        "fa": "کیلوبایت",
        "en": "KB"
    },
    "first_select_an_expression": {
        "fa": "ابتدا یک عبارت را انتخاب کنید",
        "en": "First select an Expression"
    },
    "service_{service_name}_does_not_exists": {
        "fa": "سرویس {service_name} وجود ندارد",
        "en": "Service {service_name} does not exists"
    },
    "service_{service_name}_is_not_running": {
        "fa": "سرویس {service_name} اجرا نیست",
        "en": "Service {service_name} is not running"
    },
    "start_date": {
        "fa": "زمان ابتدا",
        "en": "Start date"
    },
    "request_number": {
        "fa": "شماره درخواست",
        "en": "Request Number"
    },
    "accession_number": {
        "fa": "شماره دسترسی",
        "en": "Accession Number"
    },
    "age": {
        "fa": "سن",
        "en": "Age"
    },
    "save_template": {
        "fa": "ذخیره الگو",
        "en": "Save Template"
    },
    "referring_physician_or_operator_or_report_typist_or_acceptor_or_verifier": {
        "fa": "پزشک ارجاع دهنده یا کارشناس دستگاه یا تایپ کننده یا تایید کننده یا تایید نهایی کننده گزارش",
        "en": "Referring Physician or Operator or Report Typist or Acceptor or Verifier"
    },
    "male": {
        "fa": "مرد",
        "en": "Male"
    },
    "write_to_cd": {
        "fa": "رایت بر روی سی‌دی",
        "en": "Write to CD"
    },
    "report_btn": {
        "fa": "گزارش",
        "en": "report"
    },
    "history": {
        "fa": "تاریخچه",
        "en": "History"
    },
    "you_are_not_participant_of_this_report": {
        "fa": "شما هیچ کدام از دست‌اندرکاران این ریپورت نمی‌باشید",
        "en": "You are not any participant of this report"
    },
    "can_not_save_report_without_resident_or_staff": {
        "fa": "بدون مشخص کردن رزیدنت یا استاف نمی‌توان گزارش را تکمیل کرد",
        "en": "Can not complete report without resident or staff"
    },
    "can_not_verify_report_without_staff": {
        "fa": "برای تایید نهایی باید استاف مشخص شود",
        "en": "Can not verify report without staff"
    },
    "can_not_accept_report_without_staff": {
        "fa": "برای تایید باید استاف مشخص شود",
        "en": "Can not accept report without staff"
    },
    "type_time": {
        "fa": "زمان تایپ",
        "en": "Type time"
    },
    "you_are_not_allowed_to_{new_status}": {
        "fa": "شما مجاز به {new_status} نیستید",
        "en": "You are not allowed to {new_status}"
    },
    "you_are_not_allowed_to_edit_{status}_report": {
        "fa": "شما مجاز به ویرایش گزارش {status} نیستید",
        "en": "You are not allowed to edit the {status} report"
    },
    "you_are_not_allowed_to_edit_this_report": {
        "fa": "شما مجاز به ویرایش این گزارش نیستید",
        "en": "You are not allowed to edit the this report"
    },
    "duplicated_report_for_study": {
        "fa": "برای این مراجعه قبلا یک گزارش ایجاد شده است",
        "en": "There's already a report created for this study"
    },
    "staff_is_not_allowed_to_verify_as_it": {
        "fa": "اجازه تایید نهایی با این استاف داده نشده است",
        "en": "Verifier staff is not allowed to verify as it"
    },
    "his_birth_date": {
        "fa": "تاریخ تولد از HIS",
        "en": "Birthdate from HIS"
    },
    "new_study": {
        "fa": "مراجعه جدید",
        "en": "New Study"
    },
    "accept": {
        "fa": "تایید دستیار",
        "en": "Accept"
    },
    "inpatient": {
        "fa": "بستری",
        "en": "Inpatient"
    },
    "quick_view": {
        "fa": "مشاهده سریع",
        "en": "Quick view"
    },
    "advance_view": {
        "fa": "مشاهده پیشرفته",
        "en": "Advanced view"
    },
    "advance_viewer": {
        "fa": "نمایشگر پیشرفته",
        "en": "Advanced viewer"
    },
    "measure_polygon": {
        "fa": "اندازه‌گیری چندضلعی",
        "en": "Measure Polygon"
    },
    "at": {
        "fa": "در",
        "en": "on"
    },
    "incorrect_username_password": {
        "fa": "نام کاربری یا رمز عبور اشتباه است",
        "en": "Incorrect username or password"
    },
    "incorrect_username_password.": {
        "hint": "نام کاربری اشتباه است",
        "fa": "نام کاربری یا رمز عبور اشتباه است.",
        "en": "Incorrect username or password."
    },
    "account_has_been_locked": {
        "fa": "حساب کاربری مسدود شده است. لطفا ساعتی دیگر تلاش کنید",
        "en": "Account has been locked. Please try again after an hour"
    },
    "incorrect_current_password": {
        "fa": "رمز عبور فعلی اشتباه است",
        "en": "Incorrect current password."
    },
    "current_password_is_missing": {
        "fa": "رمز عبور فعلی وارد نشده است",
        "en": "Missing current password."
    },
    "file_size": {
        "fa": "حجم فایل",
        "en": "File Size"
    },
    "change_slides": {
        "fa": "تغییر اسلاید",
        "en": "Change slide"
    },
    "full_cycle_duration": {
        "fa": "زمان انجام کل فرآیند",
        "en": "Total process time"
    },
    "include_report_verify_time": {
        "fa": "شامل زمان تایید نهایی گزارش",
        "en": "Include Report Verify Time"
    },
    "modality": {
        "fa": "نوع تصویر",
        "en": "Modality"
    },
    "send_to_his": {
        "fa": "ارسال به HIS",
        "en": "Send to HIS"
    },
    "send_to_patient": {
        "fa": "ارسال به بیمار",
        "en": "Send to Patient"
    },
    "report_will_sent_to_his": {
        "fa": "گزارش به HIS ارسال خواهد شد",
        "en": "The report will be sent to HIS"
    },
    "files_size": {
        "fa": "حجم فایل‌ها",
        "en": "Files Size"
    },
    "assistant_2": {
        "fa": "دستیار ۲",
        "en": "Assistant 2"
    },
    "assistant_1": {
        "fa": "دستیار ۱",
        "en": "Assistant 1"
    },
    "verify": {
        "fa": "تایید نهایی",
        "en": "Verify"
    },
    "incorrect_national_code": {
        "fa": "شماره ملی یا رمز ورود اشتباه است",
        "en": "Incorrect national code or password"
    },
    "verifier": {
        "fa": "تایید کننده",
        "en": "Verifier"
    },
    "Gregorian": {
        "fa": "میلادی",
        "en": "Gregorian"
    },
    "assistant": {
        "fa": "دستیار",
        "en": "Assistant"
    },
    "file_count": {
        "fa": "تعداد فایل",
        "en": "File Count"
    },
    "patient_status": {
        "fa": "وضعیت بیمار",
        "en": "Patient Status"
    },
    "his_request_id_was_not_found": {
        "fa": "شماره درخواست '{request_number}' پیدا نشد",
        "en": "Request ID '{request_number}' was not found"
    },
    "status": {
        "fa": "وضعیت",
        "en": "Status"
    },
    "play": {
        "fa": "پخش",
        "en": "Play"
    },
    "description": {
        "fa": "توضیحات",
        "en": "Description"
    },
    "desc": {
        "fa": "توضیحات",
        "en": "Description"
    },
    "study.comments": {
        "fa": "توضیحات مراجعه",
        "en": "Study Comments"
    },
    "study.description": {
        "fa": "توصیف مراجعه",
        "en": "Study Description"
    },
    "patient.desc": {
        "fa": "توضیحات بیمار",
        "en": "Patient Description"
    },
    "until_typed_duration": {
        "fa": "زمان تا تایپ",
        "en": "Time until type"
    },
    "first_select_a_template": {
        "fa": "ابتدا یک الگو انتخاب کنید",
        "en": "First select a Template"
    },
    "new_template_was_created": {
        "fa": "الگوی جدید ایجاد شد",
        "en": "New template was created"
    },
    "template_was_updated": {
        "fa": "الگو به روز شد",
        "en": "The template was updated"
    },
    "new_study_filter_was_created": {
        "fa": "فیلتر جستجوی جدید ایجاد شد",
        "en": "New template was created"
    },
    "study_filter_was_updated": {
        "fa": "فیلتر جستجو به روز شد",
        "en": "The template was updated"
    },
    "default_study_filter_id_was_set": {
        "fa": "فیلتر جستجوی پیش‌فرض تنظیم شد",
        "en": "Default study filter was set"
    },
    "last_read_changelog_id_was_set": {
        "fa": "تغییرات جدید به عنوان خوانده شده ثبت شد",
        "en": "New changes was marked as read"
    },
    "field_{field}_can_not_be_blank": {
        "fa": "فیلد '{field}' باید مقدار داشته باشد",
        "en": "Field '{field}' can not be blank"
    },
    "field_can_not_be_blank": {
        "fa": "فیلد باید مقدار داشته باشد",
        "en": "Field can not be blank"
    },
    "copy_to_flash": {
        "fa": "کپی بر روی فلش/هارد",
        "en": "Copy on the flash/hard"
    },
    "his_name": {
        "fa": "نام از اچ‌آی‌اس",
        "en": "HIS name"
    },
    "fa": {
        "fa": "فارسی",
        "en": "Persian"
    },
    "Radiologist": {
        "fa": "رادیولوژیست",
        "en": "Radiologist"
    },
    "report_description_or_findings_or_impression": {
        "fa": "نام توصیفی یا یافته‌ها یا خلاصه گزارش",
        "en": "Report Description or Finding or Impression"
    },
    "user": {
        "fa": "کاربر",
        "en": "َUser"
    },
    "maximum_rows": {
        "fa": "حداکثر سطر",
        "en": "Maximum Rows"
    },
    "date": {
        "fa": "تاریخ",
        "en": "Date"
    },
    "from_last_week": {
        "fa": "از هفته پیش",
        "en": "From last week"
    },
    "system_maintenance_has_expired": {
        "fa": "فاقد پشتیبانی",
        "en": "System maintenance has been expired"
    },
    "Report is not verified yet": {
        "fa": "این گزارش توسط رزیدنت تهیه شده و به تایید استاف نرسیده است",
        "en": "Report is not verified yet"
    },
    "until_accepted_duration": {
        "fa": "زمان تا تایید دستیار",
        "en": "Time until accept"
    },
    "patient_info": {
        "fa": "مشخصات بیمار",
        "en": "Patient info"
    },
    "client_is_expired": {
        "fa": "کلاینت شما در تاریخ {client.expire_date} منقضی شده است",
        "en": "Client {client.aetitle} is expired at {client.expire_date}"
    },
    "range_date": {
        "fa": "بازه تاریخی",
        "en": "Date range"
    },
    "expression": {
        "fa": "عبارت",
        "en": "Expression"
    },
    "patient_list": {
        "fa": "لیست بیمارها",
        "en": "Patient List"
    },
    "show_image": {
        "fa": "نمایش تصویر",
        "en": "Show Image"
    },
    "birth_date": {
        "fa": "تاریخ تولد",
        "en": "Birthdate"
    },
    "typist": {
        "fa": "تایپیست",
        "en": "َTypist"
    },
    "typist2": {
        "fa": "تایپیست سطح دو",
        "en": "َTypist second level"
    },
    "left": {
        "fa": "چپ",
        "en": "Left"
    },
    "pre_download": {
        "fa": "پیش دانلود فایلهای دایکام",
        "en": "Pre-Download DICOM files"
    },
    "batch_download": {
        "fa": "دانلود دسته‌ای فایلها",
        "en": "Batch-Download files"
    },
    "download": {
        "fa": "دانلود",
        "en": "Download"
    },
    "study_reason": {
        "fa": "علت مراجعه",
        "en": "Study reason"
    },
    "surgical_history": {
        "fa": "سابقه عمل جراحی",
        "en": "Surgical history"
    },
    "his_comments": {
        "fa": "توضیحات مراجعه",
        "en": "Study comments"
    },
    "external_object_in_body": {
        "fa": "شیء خارجی در بدن",
        "en": "External object in body"
    },
    "report_created_as_draft_by_typist": {
        "fa": "گزارش به عنوان پیش نویس ذخیره شد. پس از تکمیل آن را نهایی کنید تا توسط رزیدنت/استاف تایید شود",
        "en": "Report created as draft. After completing save it as final to be verified by resident/staff"
    },
    "report_created_as_draft_by_assistant": {
        "fa": "گزارش به عنوان پیش نویس ذخیره شد و تا قبل از تایید شما توسط سایرین قابل رویت نخواهد بود",
        "en": "Report created as draft and it is not visible by others until you accept it"
    },
    "report_created_as_draft_by_staff": {
        "fa": "گزارش به عنوان پیش نویس ذخیره شد و تا قبل از تایید شما توسط سایرین قابل رویت نخواهد بود",
        "en": "Report created as draft and is not visible by others until you accept it"
    },
    "report_created_as_typed_by_typist": {
        "fa": "گزارش تایپ شده ذخیره شد و برای رزیدنت و برای دستیار / استاف مربوطه ارسال گردید",
        "en": "Report saved as typed and it is sent to the related resident/staff"
    },
    "report_created_as_typed_by_assistant": {
        "fa": "گزارش تایپ شده ذخیره شد ولی نیازمند تایید است",
        "en": "Report saved as typed but requires to be accepted by you"
    },
    "report_created_as_accepted_by_assistant": {
        "fa": "گزارش تایید شده و در بخش‌ها قابل رویت است",
        "en": "Report accepted and is visible by all"
    },
    "report_created_as_verified_by_assistant": {
        "fa": " گزارش تایید نهایی شد و به HIS ارسال خواهد شد",
        "en": "Report has verified and will sent to HIS"
    },
    "report_created_as_typed_by_staff": {
        "fa": "گزارش تایپ شده ذخیره شد ولی نیازمند تایید دستیار و یا تایید نهایی است",
        "en": "Report saved as typed but requires to be accepted by assistant or verify by you"
    },
    "report_created_as_accepted_by_staff": {
        "fa": "گزارش تایید شده و در بخش‌ها قابل رویت است ولی باید توسط شما تایید نهایی شود",
        "en": "Report accepted and is visible by all but should be verified you"
    },
    "report_created_as_verified_by_staff": {
        "fa": " گزارش تایید نهایی شد و به HIS ارسال خواهد شد",
        "en": "Report has verified and will sent to HIS"
    },
    "report_created_as_sent_to_his_by_staff": {
        "fa": "گزارش به HIS ارسال شد",
        "en": "Report has was sent to HIS"
    },
    "updated": {
        "fa": "به روزرسانی شد",
        "en": "updated"
    },
    "patient_saved": {
        "fa": "اطلاعات بیمار ذخیره شد",
        "en": "Patient is saved"
    },
    "his_data_fetched": {
        "fa": "دریافت اطلاعات انجام شد",
        "en": "Data fetched from HIS"
    },
    "his_admitted": {
        "fa": "پذیرش در HIS انجام شد",
        "en": "Request is admitted"
    },
    "his_report_stored": {
        "fa": "گزارش در HIS ذخیره شد",
        "en": "Report stored in HIS"
    },
    "use_admin_at_{url}_to_change_dicom_tags": {
        "fa": "برای تغییر تگ‌های دایکام از پنل مدیریتی به آدرس {url} استفاده کنید",
        "en": "In order to change DICOM tags use admin panel at {url}"
    },
    "in_{modality}_from_{body_part}": {
        "fa": "در {modality} انجام شده از {body_part}",
        "en": "In {modality} from {body_part}"
    },
    "in_{modality}": {
        "fa": "در {modality} انجام شده",
        "en": "In {modality}"
    },
    "general_failure": {
        "fa": "خطایی در سرور پکس رخ داد. برای بررسی جزییات خطا با پشتیبان تماس بگیرید",
        "en": "An exception occurred in server. For more information on the error call support"
    },
    "report_header": {
        "fa": "سربرگ",
        "en": "Header"
    },
    "font_size": {
        "fa": "اندازه قلم",
        "en": "Font size"
    },
    "no_report": {
        "fa": "فاقد گزارش",
        "en": "No report"
    },
    "plus_ctrl_enter": {
        "fa": "+ کنترل و اینتر",
        "en": "+ (Ctrl+Enter)"
    },
    "enable": {
        "fa": "فعال",
        "en": "Enable"
    },
    "disable": {
        "fa": "غیرفعال",
        "en": "Disable"
    },
    "general": {
        "fa": "عمومی",
        "en": "General"
    },
    "signature": {
        "fa": "امضاء",
        "en": "Signature"
    },
    "print_report": {
        "fa": "چاپ گزارش",
        "en": "Print report"
    },
    "edit_report": {
        "fa": "ویرایش گزارش",
        "en": "Edit report"
    },
    "create_report": {
        "fa": "ایجاد گزارش",
        "en": "Create report"
    },
    "upload": {
        "fa": "بارگذاری",
        "en": "Upload"
    },
    "upload_succeed": {
        "fa": "بارگذاری یا موفقیت انجام شد",
        "en": "Upload succeed"
    },
    "select_signature_file": {
        "fa": "انتخاب فایل امضا",
        "en": "Select signature file"
    },
    "signature_saved": {
        "fa": "امضا ذخیره شد",
        "en": "Signature saved"
    },
    "report_marked_as_not_typeed": {
        "fa": "وضعیت تایپ شده گزارش حذف شد",
        "en": "Report is now not typed"
    },
    "patient_code_not_match_with_id": {
        "fa": "شناسه بیمار {id} با کد بیمار {patient_code} مطابقت ندارد",
        "en": "Patient id {id} with code {patient_code} does not match"
    },
    "missing_required_arguments": {
        "fa": "مقادیر زیر مشخص نشده است: {insufficient_arguments}",
        "en": "Some arguments are missing: {insufficient_arguments}"
    },
    "missing_required_argument": {
        "fa": "فیلد '{insufficient_arguments}' باید مقدار داشته باشد",
        "en": "Field '{insufficient_arguments}' can not be blank"
    },
    "extra_argument_passed": {
        "fa": "مقدار اضافی {extra_arguments} ارسال شده",
        "en": "Extra argument '{extra_arguments}' is passed"
    },
    "data_too_long": {
        "fa": "طول داده '{data}' برای فیلد '{field}' خیلی زیاد است",
        "en": "Data '{data}' is too long for field '{field}'"
    },
    "editor": {
        "fa": "ویرایشگر",
        "en": "Editor"
    },
    "simple": {
        "fa": "ساده",
        "en": "Simple"
    },
    "advanced": {
        "fa": "پیشرفته",
        "en": "Advanced"
    },
    "insert_images": {
        "fa": "درج تصاویر",
        "en": "Insert images"
    },
    "space": {
        "fa": "فاصله",
        "en": "Space"
    },
    "period": {
        "fa": "نقطه",
        "en": "Period"
    },
    "_is_not_allowed_for_expression_hotkey": {
        "fa": "به عنوان کلید میانبر عبارت قابل استفاده نیست ",
        "en": "is not usable as expression hotkey"
    },
    "shortcut_is_already_used": {
        "fa": "کلید میانبر قبلا استفاده شده است",
        "en": "The shortcut is already used"
    },
    "expression_was_deleted": {
        "fa": "عبارت حذف شد",
        "en": "Expression was deleted"
    },
    "expression_was_created": {
        "fa": "عبارت جدید ایجاد شد",
        "en": "New expression was created"
    },
    "expression_was_updated": {
        "fa": "عبارت به روز شد",
        "en": "Expression was updated"
    },
    "template_was_deleted": {
        "fa": "الگو حذف شد",
        "en": "Template was deleted"
    },
    "his_sex": {
        "fa": "جنسیت دریافت شده از HIS",
        "en": "Sex from HIS"
    },
    "sex_from_his": {
        "fa": "جنسیت دریافت شده از HIS",
        "en": "Sex from HIS"
    },
    "sex_from_modality": {
        "fa": "جنسیت دریافت شده از دستگاه",
        "en": "Sex from Modality"
    },
    "pictures": {
        "fa": "تصاویر",
        "en": "Pictures"
    },
    "total_pictures": {
        "fa": "تمام تصاویر",
        "en": "Total pictures"
    },
    "selected_pictures": {
        "fa": "تصاویر انتخاب شده",
        "en": "Selected pictures"
    },
    "config_saved": {
        "fa": "تنظیمات ذخیره شد",
        "en": "Config saved"
    },
    "code": {
        "fa": "کد",
        "en": "Code"
    },
    "subject": {
        "fa": "عنوان",
        "en": "Subject"
    },
    "patient_file": {
        "fa": "پرونده بیمار",
        "en": "Patient file"
    },
    "html_is_acceptable_in_version_3_only": {
        "fa": "تگ‌های HTML در این نوع گزارش قابل قبول نیست",
        "en": "HTML tags is not allowed in this type of report"
    },
    "receiving": {
        "fa": "درحال دریافت...",
        "en": "receiving..."
    },
    "register_first": {
        "fa": "ابتدا مشخصات بیمار را ثبت کنید",
        "en": "First register patient and study info"
    },
    "err_patient_name_in_dicom_should_be_latin": {
        "fa": "با توجه به محدودیت بعضی از نمایشگرهای دایکام، نام و نام خانوادگی بیمار باید لاتین باشد",
        "en": "Due to limitations in some dicom viewer, you have to set patient names in latin"
    },
    "err_patient_id_and_patient_national_code_not_related": {
        "fa": "کد ملی {national_code} با شماره پرونده {patient_id} همخوانی ندارد. کد ملی ثبت شده در HIS برای این شماره پرونده {his_national_code} است.",
        "en": "Patient id {patient_id} and National Code {national_code} are not related. The national code for this patient registered at HIS is {his_patient.national_code}"
    },
    "preview_picture": {
        "fa": "پیش نمایش تصویر",
        "en": "preview picture"
    },
    "out_of_support": {
        "fa": "فاقد پشتیبانی",
        "en": "Out of support"
    },
    "support_will_expire_within_{days}_days": {
        "fa": "{days} روز مانده تا پایان پشتیبانی",
        "en": "Support will end within {days} days"
    },
    "trial_has_expired": {
        "fa": "مهلت دموی آزمایشی به پایان رسیده است",
        "en": "Trial has expired"
    },
    "trial_will_expire_within_{days}_days": {
        "fa": "{days} روز مانده تا پایان مهلت دمو",
        "en": "Your trial will expire within {days} days"
    },
    "working_shift": {
        "fa": "شیفت کاری",
        "en": "Working shift"
    },
    "voices": {
        "fa": "گزارش صوتی",
        "en": "Voices"
    },
    "voice_deleted": {
        "fa": "صوت حذف شد",
        "en": "Voice was deleted"
    },
    "more_patient_id_found_from_his": {
        "fa": "با توجه به استعلام از HIS کدهای جدیدی برای این کد پرونده دریافت شد",
        "en": "According to HIS, more results are fetched for this patient id"
    },
    "more_patient_id_found_from_national_code": {
        "fa": "با توجه به شماره ملی بیمار کدهای جدیدی برای این کد پرونده دریافت شد",
        "en": "According to the National Code, more results are fetched for this patient id"
    },
    "page_size": {
        "fa": "اندازه صفحه",
        "en": "Page size"
    },
    "full_history": {
        "fa": "تاریخچه کامل",
        "en": "Full history"
    },
    "additional_search_by_national_code_and_other_patient_ids": {
        "fa": "جستجوی بیشتر با توجه به شماره ملی و سایر کدهای پرونده",
        "en": "Additional search based on national code and other patient IDs"
    },
    "my_reports": {
        "fa": "گزارش‌های من",
        "en": "My reports"
    },
    "similarity_help": {
        "fa": "نمایش نتایجی که عبارت جستجو در هر قسمتی از متن قرار گرفته است",
        "en": "Show results that search expression is everywhere of data"
    },
    "my_reports_help": {
        "fa": "گزارش‌هایی که من به عنوان تایپیست، دستیار و یا استاف آن‌ها هستم",
        "en": "Reports that I am either typist, resident or the staff of them"
    },
    "report_filter_help": {
        "fa": "عبارتی از عنوان یا یافته‌ها و یا چکیده گزارش",
        "en": "A phrase of report description or findings or summary"
    },
    "ago": {
        "fa": "پیش",
        "en": "ago"
    },
    "now": {
        "fa": "اکنون",
        "en": "now"
    },
    "new": {
        "fa": "جدید",
        "en": "new"
    },
    "total": {
        "fa": "مجموع",
        "en": "Total"
    },
    "compress": {
        "fa": "فشرده‌سازی",
        "en": "Compress"
    },
    "compress_and_download": {
        "fa": "فشرده‌سازی و دریافت",
        "en": "Compress and download"
    },
    "patient_id_is_missing": {
        "fa": "کد بیمار باید مقدار داشته باشد",
        "en": "Patient id is required"
    },
    "modalities_is_missing": {
        "fa": "نوع تصویر باید مقدار داشته باشد",
        "en": "Modality is required"
    },
    "reset": {
        "fa": "ریست",
        "en": "Reset"
    },
    "totalSize": {
        "fa": "حجم کل",
        "en": "Total size"
    },
    "totalCount": {
        "fa": "تعداد کل",
        "en": "Total count"
    },
    "verify_with_staff": {
        "fa": "تایید با حضور استاف",
        "en": "Verify with staff"
    },
    "verify_without_staff": {
        "fa": "تایید بدون حضور استاف",
        "en": "Verify without staff"
    },
    "with_staff": {
        "fa": "با حضور استاف",
        "en": "with staff"
    },
    "without_staff": {
        "fa": "بدون حضور استاف",
        "en": "without staff"
    },
    "report_with_staff_is_not_set": {
        "fa": "وضعیت حضور استاف مشخص نشده است",
        "en": "Staff status is not specified"
    },
    "allow_residents_to_verify_with_me": {
        "fa": "دستیار مجاز است گزارش‌ها را با نام من تایید نهایی کند",
        "en": "Residents are allowed to verify reports with my name"
    },
    "not_selected": {
        "fa": "انتخاب نشده",
        "en": "Not selected"
    },
    "service_code": {
        "fa": "کد خدمات",
        "en": "Service code"
    },
    "request": {
        "fa": "درخواست",
        "en": "Request"
    },
    "register": {
        "fa": "ثبت",
        "en": "Register"
    },
    "his_requests": {
        "fa": "درخواستهای اچ‌آی‌اس",
        "en": "HIS Requests"
    },
    "other": {
        "fa": "سایر",
        "en": "Other"
    },
    "auto": {
        "fa": "اتوماتیک",
        "en": "Automatic"
    },
    "large": {
        "fa": "بزرگ",
        "en": "Large"
    },
    "medium": {
        "fa": "متوسط",
        "en": "Medium"
    },
    "small": {
        "fa": "کوچک",
        "en": "Small"
    },
    "series": {
        "fa": "سری‌ها",
        "en": "Series"
    },
    "none": {
        "fa": "هیچ‌کدام",
        "en": "None"
    },
    "select_report": {
        "fa": "انتخاب گزارش",
        "en": "Select report"
    },
    "password_{min_len}_error": {
        "fa": "طول رمز ورود حداقل باید {min_len} کاراکتر باشد",
        "en": "Password length should be at least {min_len} characters"
    },
    "password_strength_error": {
        "fa": "رمز عبور باید شامل حروف کوچک، حروف بزرگ، اعداد و کاراکترهای خاص باشد",
        "en": "Password should contains capital and small letters, digits and symbols"
    },
    "auth_err_login": {
        "fa": "لطفا دوباره لاگین کنید",
        "en": "Login again please"
    },
    "sent_to_his_time": {
        "fa": "زمان ارسال به HIS",
        "en": "sent to his time"
    },
    "action": {
        "fa": "عملیات",
        "en": "action"
    },
    "study": {
        "fa": "مراجعه",
        "en": "study"
    },
    "client": {
        "fa": "کلاینت",
        "en": "client"
    },
    "succeeded": {
        "fa": "با موفقیت انجام شد",
        "en": "succeeded"
    },
    "incorrect_port_number": {
        "fa": "شماره پورت اشتباه است",
        "en": "Incorrect port number"
    },
    "days": {
        "fa": "روزها",
        "en": "days"
    },
    "day": {
        "fa": "روز",
        "en": "day"
    },
    "loading": {
        "fa": "در حال بارگذاری...",
        "en": "Loading..."
    },
    "guest": {
        "fa": "میهمان",
        "en": "Guest"
    },
    "you_are_not_allowed_delete_another_expression": {
        "fa": "you_are_not_allowed_delete_another_expression",
        "en": "you are not allowed delete another expression"
    },
    "report_created_as_verified_by_admin": {
        "fa": "report_created_as_verified_by_admin",
        "en": "report created as verified by admin"
    },
    "report_created_as_draft_by_admin": {
        "fa": "report_created_as_draft_by_admin",
        "en": "report created as draft by admin"
    },
    "report_created_as_typed_by_admin": {
        "fa": "report_created_as_typed_by_admin",
        "en": "report created as typed by admin"
    },
    "wrong_type_error": {
        "fa": "نوع اشتباه است.",
        "en": "Wrong type entered!!!"
    },
    "empty_error": {
        "fa": "چیزی برای نمایش وجود ندارد.",
        "en": "Nothing to show!!!"
    },
    "no_pattern": {
        "fa": "الگویی تاکنون ثبت نکرده اید",
        "en": "No pattern found!"
    },
    "add_pattern_msg": {
        "fa": "برای ثبت اولین الگوی خود بر روی دکمه زیر کلیک کنید",
        "en": "Click below button to add your first pattern."
    },
    "add_new_pattern": {
        "fa": "افزودن الگوی جدید",
        "en": "Add new pattern"
    },
    "new_template": {
        "fa": "الگوی جدید",
        "en": "New template"
    },
    "delete_template_confirmation": {
        "fa": "آیا از حذف الگو اطمینان دارید؟",
        "en": "Are tou sure to delete this template"
    },
    "spax": {
        "fa": "سیناپکس",
        "en": "SPAX"
    },
    "spax_time": {
        "fa": "۱۳۹۴−۱۴۰۲",
        "en": "1394-1402"
    },
    "visit_time": {
        "fa": "تاریخ مراجعه",
        "en": "Study Time"
    },
    "item": {
        "fa": "مورد",
        "en": "Item"
    },
    "site_settings": {
        "fa": "تنظیمات سایت",
        "en": "Site Settings"
    },
    "profile": {
        "fa": "پروفایل",
        "en": "Profile"
    },
    "your_profile": {
        "fa": "پروفایل شما",
        "en": "Your Profile"
    },
    "new_password": {
        "fa": "رمز عبور جدید",
        "en": "New Password"
    },
    "cancel": {
        "fa": "لغو",
        "en": "Cancel"
    },
    "public_settings": {
        "fa": "تنظیمات کلی",
        "en": "Public Settings"
    },
    "site": {
        "fa": "سایت",
        "en": "Site"
    },
    "jalali": {
        "fa": "شمسی",
        "en": "Jalali"
    },
    "gregorian": {
        "fa": "میلادی",
        "en": "Gregorian"
    },
    "advance_access": {
        "fa": "دسترسی پیشرفته",
        "en": "Advance Access"
    },
    "double_click": {
        "fa": "دابل کلیک",
        "en": "Double Click"
    },
    "double_click_tooltip": {
        "fa": "با انتخاب یکی از گزینه‌های موجود می‌توانید در پنل اصلی با دابل کلیک و بدون نیاز به کلیک روی آیکون مورد نظر وارد همان صفحه شوید",
        "en": "By choose one of the options, you can quickly enter to chosen page"
    },
    "can_predownload": {
        "fa": "امکان پیش دانلود فایل وجود داشته باشد",
        "en": "Can Predownload File"
    },
    "permissions": {
        "fa": "اجازه های دسترسی",
        "en": "Permissions"
    },
    "can_assistance": {
        "fa": " دستیاران من اجازه تایید گزارش را دارد",
        "en": "My Assistants can verify reports"
    },
    "create_final_link": {
        "fa": "در حال ساخت لینک نهایی",
        "en": "Creating Final Link Now"
    },
    "remaining_time": {
        "fa": "زمان باقی مانده",
        "en": "Remaining Time"
    },
    "download_link": {
        "fa": "لینک دانلود",
        "en": "Download Link"
    },
    "download_file": {
        "fa": "دانلود فایل",
        "en": "Download File"
    },
    "return": {
        "fa": "برگشت",
        "en": "Return"
    },
    "selected_item": {
        "fa": "موارد انتخاب شده",
        "en": "Selected Item"
    },
    "total_files": {
        "fa": "مجموع فایل ها",
        "en": "Total Files"
    },
    "choose_user": {
        "fa": "همه کاربران",
        "en": "All Users"
    },
    "total_amount": {
        "fa": "مجموع حجم",
        "en": "Total Amount"
    },
    "amount": {
        "fa": "حجم",
        "en": "Amount"
    },
    "file_format": {
        "fa": "فرمت فایل",
        "en": "File Format"
    },
    "file_name": {
        "fa": "نام فایل",
        "en": "File Name"
    },
    "want_DICOM_viewer": {
        "fa": "نرم افزار مشاهده DICOM",
        "en": "DICOM Viewer"
    },
    "media": {
        "fa": "مدیا",
        "en": "Media"
    },
    "zip_file": {
        "fa": "فایل فشرده (ZIP)",
        "en": "Zip File"
    },
    "iso_file": {
        "fa": "فایل ایمیج (ISO)",
        "en": "Iso File"
    },
    "want_report": {
        "fa": "گزارش پی‌دی‌اف",
        "en": "PDF Report"
    },
    "anonymous": {
        "fa": "Anonymous (مشخصات فرد نمایش داده نشود)",
        "en": "Anonymous"
    },
    "create_download_link": {
        "fa": "ساخت لینک دانلود",
        "en": "Creating Download Link"
    },
    "pick_date": {
        "fa": "انتخاب تاریخ",
        "en": "Pick Date"
    },
    "3day": {
        "fa": "۳ روز",
        "en": "3days"
    },
    "week": {
        "fa": "هفته",
        "en": "Week"
    },
    "month": {
        "fa": "ماه",
        "en": "Month"
    },
    "year": {
        "fa": "سال",
        "en": "Year"
    },
    "enter_login": {
        "fa": "لطفا نام کاربری و رمز عبور خود را وارد کنید",
        "en": "Please enter username and password"
    },
    "not_found": {
        "fa": "موردی یافت نشد!",
        "en": "!Not Found"
    },
    "{data}_not_found": {
        "fa": "{data} وجود ندارد",
        "en": "{data} doesn't exists"
    },
    "from_date": {
        "fa": "از تاریخ",
        "en": "From Date"
    },
    "to_date": {
        "fa": "تا تاریخ",
        "en": "To Date"
    },
    "datepickerFrom": {
        "fa": "از تاریخ",
        "en": "From Date"
    },
    "datepickerTo": {
        "fa": "تا تاریخ",
        "en": "To Date"
    },
    "all_status": {
        "fa": "همه وضعیت ها",
        "en": "All Status"
    },
    "copy_right": {
        "fa": "Copyright 2022 © Negin Rayaneh",
        "en": "Copyright 2022 © Negin Rayaneh"
    },
    "delete_template": {
        "fa": "حذف الگو",
        "en": "Delete Template"
    },
    "edit_template": {
        "fa": "ویرایش الگو",
        "en": "Edit Template"
    },
    "quantity": {
        "fa": "تایی",
        "en": ""
    },
    "shortcut_placeholder": {
        "fa": "مثلا: PTN",
        "en": "for example: PTN"
    },
    "shortcut_explanation": {
        "fa": "برای اعمال باید بعد از تایپ میانبر، کلید های اینتر و کنترل را بفشارید.",
        "en": "To replace shortcut with long text, you must move cursor at the end of shortcut then press CTRL+ENTER keys at same time"
    },
    "ctrl_enter": {
        "fa": " + کنترل و اینتر",
        "en": "Ctrl + Enter"
    },
    "patient_last_name": {
        "fa": "نام خانوادگی بیمار",
        "en": "Patient Last Name"
    },
    "from_date_to_date": {
        "fa": "از تاریخ {date1} الی تاریخ {date2}",
        "en": "from {date1} till {date2}"
    },
    "image_report_description": {
        "fa": "توضیحات عکس",
        "en": "Image description"
    },
    "interval": {
        "fa": "بازه زمانی",
        "en": "interval"
    },
    "patterns": {
        "fa": "الگوها",
        "en": "patterns"
    },
    "save_new_expression": {
        "fa": "ذخیره عبارت جدید",
        "en": "Save New Expression"
    },
    "new_expression_text": {
        "fa": "متن عبارت جدید",
        "en": "New Expression text"
    },
    "new_expression_title": {
        "fa": "عنوان عبارت جدید",
        "en": "New Expression Title"
    },
    "report_title": {
        "fa": "عنوان گزارش",
        "en": "Report title"
    },
    "new_expression_title_placeholder": {
        "fa": "مثلا سر و لگن اورژانسی",
        "en": "for example: ??? "
    },
    "template_title": {
        "fa": "عنوان قالب",
        "en": "Template title"
    },
    "template_subject": {
        "fa": "موضوع قالب",
        "en": "Template subject"
    },
    "template_subject_placeholder": {
        "fa": "عنوان الگو",
        "en": "Template subject"
    },
    "template_title_placeholder": {
        "fa": "عنوان الگو",
        "en": "Template subject"
    },
    "template_findings": {
        "fa": "الگو جدید در یافته ها",
        "en": "Template in findings"
    },
    "new_template_findings_placeholder": {
        "fa": "متن الگو",
        "en": "Template Finding"
    },
    "view_report": {
        "fa": "مشاهده گزارش",
        "en": "View report"
    },
    "view_reports": {
        "fa": "مشاهده گزارش‌ها",
        "en": "View reports"
    },
    "doctor_or_user": {
        "fa": "پزشک / کاربر",
        "en": "Doctor / User"
    },
    "which_report_will_select": {
        "fa": "کدام گزارش را انتخاب میکنید؟",
        "en": "Which report will be choce?"
    },
    "report_from_Local": {
        "fa": "گزارش ذخیره شده در سیستم",
        "en": "Local Report"
    },
    "report_from_server": {
        "fa": "گزارش سرور",
        "en": "Report from Server"
    },
    "apply_changes": {
        "fa": "اعمال تغییرات",
        "en": "Apply changes"
    },
    "create_expression": {
        "fa": "ایجاد عبارت",
        "en": "Create expression"
    },
    "update_list": {
        "fa": "به روزرسانی لیست",
        "en": "Update list"
    },
    "your_signature": {
        "fa": "امضا شما",
        "en": "Your signature"
    },
    "your_templates": {
        "fa": "الگوهای شما",
        "en": "Your temmplates"
    },
    "last_edit": {
        "fa": "آخرین ویرایش",
        "en": "Last edit"
    },
    "upload_signature": {
        "fa": "بارگذاری امضا",
        "en": "Upload signature"
    },
    "upload_pictures": {
        "fa": "بارگذاری تصاویر",
        "en": "Upload pictures"
    },
    "expression_delete": {
        "fa": " حذف عبارت",
        "en": "Deleted expression"
    },
    "expression_delete_confirmation": {
        "fa": "آیا از حذف  این عبارت اطمینان دارید؟",
        "en": "Are tou sure to deleted expression?"
    },
    "modify_expression": {
        "fa": "ویرایش عبارت",
        "en": "Edit expression"
    },
    "select_pictures": {
        "fa": "انتخاب تصاویر",
        "en": "Select pictures"
    },
    "add_customer": {
        "fa": "افزودن مراجعه کننده",
        "en": "Add patient"
    },
    "results": {
        "fa": "نتایج",
        "en": "results"
    },
    "show": {
        "fa": "نمایش",
        "en": "show"
    },
    "manage_patterns": {
        "fa": "مدیریت الگوها",
        "en": "manage patterns"
    },
    "all_devices": {
        "fa": "همه دستگاه ها",
        "en": "All devices"
    },
    "type_here": {
        "fa": "اینجا بنویسید",
        "en": "Type here"
    },
    "to_persian": {
        "fa": "به فارسی",
        "en": "To persian"
    },
    "to_english": {
        "fa": "به انگلیسی",
        "en": "To english"
    },
    "drafted": {
        "fa": "پیش‌نویس",
        "en": "Drafted"
    },
    "admitted": {
        "fa": "پذیرش شده",
        "en": "Admitted"
    },
    "typed": {
        "fa": "تایپ شده",
        "en": "Typed"
    },
    "accepted": {
        "fa": "تایید دستیار",
        "en": "Accepted"
    },
    "verified": {
        "fa": "تایید نهایی",
        "en": "Verified"
    },
    "sent_to_his": {
        "fa": "ارسال به HIS",
        "en": "Sent To His"
    },
    "sent_to_patient": {
        "fa": "ارسال به بیمار",
        "en": "Sent To Patient"
    },
    "his_request_number_filter_placeholder": {
        "fa": "کد بیمار / کد ملی / شماره درخواست",
        "en": "Patient code / National code/ Request number"
    },
    "first_last_name": {
        "fa": "نام و نام خانوادگی",
        "en": "Full name"
    },
    "request_type": {
        "fa": "نوع درخواست",
        "en": "Request type"
    },
    "choose_report": {
        "fa": "انتخاب گزارش",
        "en": "Choose report"
    },
    "images": {
        "fa": "عکس‌ها",
        "en": "Images"
    },
    "pics_series": {
        "fa": "سری عکس",
        "en": "Pics series"
    },
    "choose_one": {
        "fa": "انتخاب کنید",
        "en": "Choose one"
    },
    "last_update": {
        "fa": "آخرین آپدیت",
        "en": "Last update"
    },
    "create_link_successed": {
        "fa": "لینک دانلود با موفقیت ایجاد شد.",
        "en": "Download link created successfully."
    },
    "network_error": {
        "fa": "عدم اتصال به شبکه",
        "en": "Network not avaiable."
    },
    "close_": {
        "fa": "بستن",
        "en": "Close"
    },
    "full_search_tooltip": {
        "fa": "جستجوی سایر شماره پرونده های مرتبط با شماره پرونده جستجو شده",
        "en": "Searches for other patient IDs related to searched one"
    },
    "report_type": {
        "fa": "وضعیت گزارش",
        "en": "Report type"
    },
    "inpatient_status": {
        "fa": "وضعیت بستری",
        "en": "Inpatient status"
    },
    "inpatient_status_title": {
        "fa": "وضعیت بستری",
        "en": "Inpatient status"
    },
    "no_action": {
        "fa": "بدون عمل",
        "en": "No action"
    },
    "signature_format": {
        "fa": "فرمت تصویر JPEG یا PNG",
        "en": "Signature format must be JPEG or PNG"
    },
    "add_patient_format": {
        "fa": "فرمت فایل‌های مجاز JPEG، PNG و یا PDF",
        "en": "File formats must be JPEG, PNG or PDF"
    },
    "others": {
        "fa": "سایر",
        "en": "Other"
    },
    "rows": {
        "fa": "ردیف",
        "en": "No."
    },
    "gender_title_male": {
        "fa": "آقای",
        "en": "Mr."
    },
    "gender_title_female": {
        "fa": "خانم",
        "en": "Mrs."
    },
    "gender_title_others": {
        "fa": "سرکار",
        "en": "Dear"
    },
    "voice": {
        "fa": "صوت",
        "en": "Voice"
    },
    "voice_report": {
        "fa": "گزارش صوتی",
        "en": "Voice Report"
    },
    "new_voice": {
        "fa": "ضبط صدا",
        "en": "New Voice"
    },
    "Verify_with_staff": {
        "fa": "تایید با حضور استاف",
        "en": "Verify with staff"
    },
    "Verify_without_staff": {
        "fa": "تایید بدون حضور استاف",
        "en": "Verify without staff"
    },
    "new_empty_report": {
        "fa": "ایجاد گزارش خالی",
        "en": "New Empty Report"
    },
    "filterـpatterns": {
        "fa": "جستجوی الگوها",
        "en": "Filter patterns"
    },
    "row_numbers": {
        "fa": "ردیف",
        "en": "No."
    },
    "edit": {
        "fa": "ویرایش",
        "en": "Edit"
    },
    "exit_sure": {
        "fa": "آیا برای خروج از سامانه اطمینان دارید؟",
        "en": "Are you sure for exit?"
    },
    "exit_yes": {
        "fa": "خروج",
        "en": "Exit"
    },
    "exit_no": {
        "fa": "ماندن",
        "en": "Stay"
    },
    "not_have": {
        "fa": "(ندارد)",
        "en": "(-)"
    },
    "patient_file_tooltip": {
        "fa": "مشاهده پرونده بیمار",
        "en": "View patient file"
    },
    "images_info_tooltip": {
        "fa": "مشاهده چند نمونه از عکس‌های سری",
        "en": "View some pics of this pic series"
    },
    "owners": {
        "fa": "دست‌اندرکاران",
        "en": "Owners"
    },
    "owner_changes": {
        "fa": "تغییرات در قسمت دست‌اندرکاران گزارش",
        "en": "Owner report changes"
    },
    "report_details": {
        "fa": "محتوای گزارش",
        "en": "Report details"
    },
    "report_situation": {
        "fa": "تعیین وضعیت",
        "en": "Report situation"
    },
    "impression_placeholder": {
        "fa": "نتیحه نهایی گزارش",
        "en": "Imppression for report"
    },
    "private": {
        "fa": "شخصی",
        "en": "Private"
    },
    "private_explanation": {
        "fa": "فقط برای شما قابل دسترس خواهد بود و به کاربران دیگر نمایش داده نمی شود",
        "en": "Private, only you can see this, and others could not see this."
    },
    "new_template_title_explanation": {
        "fa": "این عنوان برای گزارش استفاده میشود و اگر عنوان گزارش خالی باشد در قسمت عنوان گزارش قرار میگیرد",
        "en": "It uses for empty report title that placed in report title."
    },
    "new_template_subject_explanation": {
        "fa": "سعی کنید عنوان الگو مختصر باشد: در حد ۲ تا ۳ کلمه",
        "en": "Try to keep the template title short: 2-3 words"
    },
    "save_reporters_for_another_report": {
        "fa": "ذخیره برای گزارش های دیگر",
        "en": "Save reportes for another reports"
    },
    "load_saved_reporters": {
        "fa": "بازگردانی گزارشگرهای قبلی",
        "en": "Load saved reporters."
    },
    "save_reporters_for_another_report_notification": {
        "fa": "گزارشگرها با موفقیت ذخیره شدند",
        "en": "Reporters saved successfully"
    },
    "you": {
        "fa": "شما",
        "en": "You"
    },
    "me": {
        "fa": "من",
        "en": "Me"
    },
    "no_expression": {
        "fa": "هیچ عبارتی وجود ندارد.",
        "en": "there is no expression."
    },
    "no_template": {
        "fa": "هیچ الگویی وجود ندارد.",
        "en": "there is no template."
    },
    "continue_report": {
        "fa": "ادامه گزارش ->",
        "en": "Continue typing report ->"
    },
    "rtl": {
        "fa": "راست چین",
        "en": "Right to left"
    },
    "ltr": {
        "fa": "چپ چین",
        "en": "Left to right"
    },
    "remove_selected_images_and_description": {
        "fa": "همه عکسهای انتخاب شده و توضیحات آنها از قسمت انتخاب شده ها حذف شوند",
        "en": "Remove all selected images and their description."
    },
    "load_images_from_editor": {
        "fa": "انتخاب عکسهایی که در گزارش انتخاب شده‌اند",
        "en": "Load images which is used at report"
    },
    "big": {
        "fa": "بزرگ",
        "en": "Big"
    },
    "template_hint": {
        "fa": "با دوبار کلیک روی الگو، به متن شما اضافه خواهد شد",
        "en": "By double click on template, it'll add to your report"
    },
    "choose_pic_size": {
        "fa": "انتخاب ابعاد تصویر",
        "en": "Choose pic size"
    },
    "lbl_validator__please": {
        "fa": "لطفا",
        "en": "Please Enter"
    },
    "lbl_validator__required": {
        "fa": "را وارد کنید!",
        "en": " !"
    },
    "lbl_validator__Is_Not_Correct": {
        "fa": ".صحیح نیست",
        "en": "Is Not Correct"
    },
    "lbl_validator__Should_Be_Number": {
        "fa": ".باید عدد باشد",
        "en": "Should Be Number"
    },
    "this_field_required_hint": {
        "fa": ".این فیلد الزامی است و نمیتواند خالی باشد",
        "en": "This field is required and could not be empty."
    },
    "shortcut_should_not_contain_space": {
        "fa": "کلید میانبر نمی‌تواند حاوی فاصله باشد",
        "en": "shortcut should not contain space"
    },
    "version": {
        "fa": "نسخه",
        "en": "Version"
    },
    "version_changes": {
        "fa": "تغییرات در نسخه {version}: ",
        "en": "Version {version} Changes: "
    },
    "pacs_version": {
        "fa": "نسخه پکس",
        "en": "Pacs Version"
    },
    "current_password": {
        "fa": "رمز عبور فعلی",
        "en": "Current password"
    },
    "report_users": {
        "fa": "دست‌اندرکاران گزارش",
        "en": "Report users"
    },
    "view_unchangeable_reports": {
        "fa": "گزارش های غیر قابل تغییر",
        "en": "View Unchangeable Reports"
    },
    "select_gender": {
        "fa": "انتخاب جنسیت",
        "en": "Select gender"
    },
    "department": {
        "fa": "بخش",
        "en": "Department"
    },
    "search_in_list": {
        "fa": "جستجو در لیست",
        "en": "Search in List"
    },
    "select_hospital": {
        "fa": "سرور",
        "en": "Server"
    },
    "cancel_filters": {
        "fa": "لغو فیلترها",
        "en": "Cancel filters"
    },
    "remove_selected": {
        "fa": "حذف انتخاب شده‌ها",
        "en": "Remove selected"
    },
    "old_browsers_does_not_support": {
        "fa": "مرورگر شما قدیمی است و توسط این برنامه پشتیبانی نمی‌شود، سعی کنید مرورگر خود را به روز نمایید",
        "en": "Your browser is older than we can support, try update your browser."
    },
    "you_are_not_allowed_delete_another_template": {
        "fa": "شما مجاز به حذف الگوی کاربر دیگر نیستید",
        "en": "You are not allowed delete another template"
    },
    "search_button_tooltip": {
        "fa": "جستجوی فیلترهای انتخاب شده",
        "en": "Apply selected filters"
    },
    "cancel_button_tooltip": {
        "fa": "بازگشت به فیلترهای اولیه",
        "en": "Remove all selected filters"
    },
    "user_manual": {
        "fa": "راهنمای کاربری",
        "en": "User Manual"
    },
    "report_page_manual": {
        "fa": "راهنمای صفحه گزارش",
        "en": "Report Page Manual"
    },
    "next_patient": {
        "fa": "بیمار بعدی",
        "en": "Next patient"
    },
    "next_patient_name": {
        "fa": "بیمار بعدی: {name}",
        "en": "Next patient: {name}"
    },
    "prev_patient": {
        "fa": "بیمار قبلی",
        "en": "Prev patient"
    },
    "prev_patient_name": {
        "fa": "بیمار قبلی: {name}",
        "en": "Prev patient: {name}"
    },
    "reset_filters": {
        "fa": "بازنشانی فیلترها",
        "en": "Reset Filters"
    },
    "reset_this_filters": {
        "fa": "بازنشانی این فیلتر",
        "en": "Reset this Filter"
    },
    "reload_filters": {
        "fa": "بازخوانی با همین فیلترها",
        "en": "Reload Filters"
    },
    "title_homepage": {
        "fa": "{hospital} - سیناپکس",
        "en": "{hospital} - SPAX"
    },
    "title_loginPage": {
        "fa": "ورود - {hospital} - سیناپکس",
        "en": "login - {hospital} - SPAX"
    },
    "title_printPage": {
        "fa": "چاپ گزارش - سیناپکس",
        "en": "Print Report - SPAX"
    },
    "title_reportPage": {
        "fa": "{patient} - گزارش - سیناپکس",
        "en": "Report - {patient} - SPAX"
    },
    "title_viewPage": {
        "fa": "{patient} - تصاویر - سیناپکس",
        "en": "View - {patient} - SPAX"
    },
    "title_helpPage": {
        "fa": "راهنمای سیناپکس",
        "en": "Help - SPAX"
    },
    "title_404": {
        "fa": "404 - سیناپکس",
        "en": "404 - SPAX"
    },
    "report_owners": {
        "fa": "دست‌اندرکاران گزارش",
        "en": "Report owners"
    },
    "filter_setting": {
        "fa": "تنظیمات فیلترها",
        "en": "Filters setting"
    },
    "hour": {
        "fa": "ساعت",
        "en": "at"
    },
    "years_old": {
        "fa": "{value} ساله",
        "en": "{value} years"
    },
    "year_old": {
        "fa": "{value} ساله",
        "en": "{value} year"
    },
    "months_old": {
        "fa": "{value} ماهه",
        "en": "{value} months"
    },
    "month_old": {
        "fa": "{value} ماهه",
        "en": "{value} month"
    },
    "days_old": {
        "fa": "{value} روزه",
        "en": "{value} days"
    },
    "day_old": {
        "fa": "{value} روزه",
        "en": "{value} day"
    },
    "subject_results": {
        "fa": "نتایج جستجو در عنوان",
        "en": "Results of search in titles"
    },
    "findings_results": {
        "fa": "نتایج جستجو در مشاهدات",
        "en": "Results of search in findings"
    },
    "not_downloaded_yet_wait": {
        "fa": "قسمتی از اطلاعات مورد نیاز هنوز دانلود نشده‌اند، اتصال سیستم را به شبکه بررسی کنید و یا لطفا کمی صبر کنید ...",
        "en": "Some data does not downloaded yet, check network connection and please wait ..."
    },
    "click_for_login": {
        "fa": "برای ورود به پکس کلیک کنید",
        "en": "Click here for login to SPAX"
    },
    "select_both": {
        "fa": "انتخاب هردو",
        "en": "Select both"
    },
    "choose_study_filter": {
        "fa": "انتخاب فیلتر",
        "en": "Choose study filter"
    },
    "new_study_filter_title": {
        "fa": "ذخیره فیلتر",
        "en": "Save Filters"
    },
    "new_study_filter_name": {
        "fa": "نام فیلتر",
        "en": "Filter name"
    },
    "new_study_filter_name_placeholder": {
        "fa": "مثلا سی‌تی‌های گزارش نشده دیروز",
        "en": "For example Yesterday CT Not reported"
    },
    "new_study_filter_name_explanation": {
        "fa": "عنوان فیتلر که در لیست فیلترها می‌بینید",
        "en": "This is the title that you see in filter list"
    },
    "new_study_filter_add": {
        "fa": "افزودن فیلتر جدید",
        "en": "Add new study filter"
    },
    "new_study_filter_add_current": {
        "fa": "افزودن فیلترهای فعلی",
        "en": "Add current study filter"
    },
    "your_study_filter": {
        "fa": "فیلترهای انتخابی شما",
        "en": "Your Filters"
    },
    "details": {
        "fa": "جزئیات",
        "en": "Details"
    },
    "apply_filter": {
        "fa": "اعمال فیلتر",
        "en": "Apply Filter"
    },
    "fetching-data-from-server": {
        "fa": "دریافت اطلاعات از سرور...",
        "en": "Fetching data from server..."
    },
    "public_user_cant_change_settings": {
        "fa": "کاربر عمومی نمی‌تواند تنظیمات را تغییر دهد",
        "en": "Public user can't change the settings"
    },
    "study_view_is_limited_to_n_per_hour": {
        "fa": "تصاویر نمی‌تواند بیش از {n} بار در ساعت مشاهده شود",
        "en": "Study can't be viewed more than {n} times per hour"
    },
    "study_view_is_limited_to_n_per_day": {
        "fa": "حداکثر دفعات مجاز به استفاده از لینک تصاویر {n} بار در هر روز است",
        "en": "Study can't be viewed more than {n} times per day"
    },
    "outside_access_link_has_expired": {
        "fa": "لینک دسترسی مستقیم به تصاویر منقضی شده است",
        "en": "Direct link access to this study has been expired"
    },
    "register_selected": {
        "fa": "ثبت انتخاب شده‌ها",
        "en": "Register selected"
    },
    "not_same_barcode": {
        "fa": "برای ثبت، باید بیمارانی با بارکد یکسان را انتخاب نمایید",
        "en": "all selected patients must be with same request ID"
    },
    "download_excel": {
        "fa": "دانلود خروجی اکسل",
        "en": "Download excel"
    },
    "delete_study_filter_confirmation": {
        "fa": "آیا از حذف فیلتر مراجعه اطمینان دارید؟",
        "en": "Are tou sure to delete this study filter"
    },
    "delete_study_filter_confirmation_with_name": {
        "fa": "آیا از حذف فیلتر مراجعه « {name} » اطمینان دارید؟",
        "en": "Are tou sure to delete study filter ' {name} ' ?"
    },
    "quick_filters_list": {
        "fa": "لیست فیلترهای مراجعه",
        "en": "Study filters list"
    },
    "outside_daily_access_link_has_expired": {
        "fa": "لینک دسترسی مستقیم روزانه به تصاویر منقضی شده است",
        "en": "Daily Direct link access to this study has been expired"
    },
    "your_not_allowed_to_delete_another_user_filter": {
        "fa": "شما مجاز به حذف فیلترهای کاربر دیگر نیستید",
        "en": "You are not allowed to delete another user filters"
    },
    "study_filter_was_removed": {
        "fa": "فیلتر حذف شد",
        "en": "Filter was removed"
    },
    "filter_details": {
        "fa": "جزئیات فیلتر مراجعه",
        "en": "View study filter details"
    },
    "study_filter_management": {
        "fa": "مدیریت فیلترهای مراجعه",
        "en": "Study Filters managements"
    },
    "study_filter_title": {
        "fa": "عنوان فیلترهای مراجعه",
        "en": "Study Filters title"
    },
    "study_filter_new": {
        "fa": "ثبت فیلتر جدید",
        "en": "Add new Study Filter"
    },
    "study_filter_cancel": {
        "fa": "لغو فیلتر",
        "en": "Cancel Filter"
    },
    "default": {
        "fa": "پیش‌فرض",
        "en": "Default"
    },
    "structural_report": {
        "fa": "گزارش ساخت یافته",
        "en": "Structural report"
    },
    "select_language": {
        "fa": "انتخاب زبان",
        "en": "Select language"
    },
    "choose_report_language": {
        "fa": "انتخاب زبان گزارش",
        "en": "Choose report language"
    },
    "choose_report_group": {
        "fa": "انتخاب گروه گزارش",
        "en": "Choose report group"
    },
    "show_preview": {
        "fa": "مشاهده پیش‌نمایش",
        "en": "Show preview"
    },
    "procedure": {
        "fa": "روش انجام",
        "en": "Procedure"
    },
    "set_as_default": {
        "fa": "فیلتر «{name}» بعنوان پیش‌فرض انتخاب شد",
        "en": "Filter \"{name}\" set as default"
    },
    "url_not_found": {
        "fa": "آدرس مورد نظر پیدا نشد",
        "en": "URL not found"
    },
    "or": {
        "fa": "یا",
        "en": "Or"
    },
    "mobile_mode_not_allowed_to": {
        "fa": "دسترسی به این قابلیت در حالت موبایلی امکان پذیر نمی‌باشد",
        "en": "this is not allowed on Mobile mode"
    },
    "multiple_study_with_{request_number}": {
        "fa": "بیش از یک رکورد با شماره درخواست {request_number} وجود دارد",
        "en": "Multiple records with request number {request_number} is exists"
    },
    "record_does_not_exists": {
        "fa": "رکورد مورد نظر وجود ندارد",
        "en": "Record does not exists"
    },
    "{table}.{id}_does_not_exists": {
        "fa": "{table} با شناسه {id} وجود ندارد",
        "en": "{table} id {id} does not exists"
    },
    "low_space_on_short_term": {
        "fa": "فضای ذخیره سازی تصاویر در حال پر شدن است",
        "en": "Image storage space is filling up"
    },
    "no_space_on_short_term": {
        "fa": "فضای کافی برای ذخیره سازی تصاویر جدید وجود ندارد",
        "en": "There is not enough space to store new images"
    },
    "end_larger_than_start_date": {
        "fa": "تاریخ انتهای بازه نمیتواند بعد از تاریخ ابتدای بازه باشد",
        "en": "End date could not be before start date"
    },
    "link_sent_to_patient": {
        "fa": "لینک برای بیمار در مورخه {date}، ساعت {time} ارسال شد",
        "en": "Link sent to patient on {date} at {time}"
    },
    "default_range_date": {
        "fa": "ریست بازه تاریخی",
        "en": "Reset to default range date"
    },
    "description_name_changes": {
        "fa": "تغییرات در عنوان گزارش",
        "en": "Description Name Changes"
    },
    "findings_changes": {
        "fa": "تغییرات در یافته‌ها",
        "en": "Findings Changes"
    },
    "impression_changes": {
        "fa": "تغییرات در نتیجه نهایی",
        "en": "Impression Changes"
    },
    "others_findings": {
        "fa": "لیست دیگر کاربرانی که برای این گزارش یافته‌های ثبت نشده دارند",
        "en": "Other users does not saved findings"
    },
    "describable_changes": {
        "fa": "تغییرات در قسمت مشروح گزارش",
        "en": "Describable report changes"
    },
    "resource_not_authorized": {
        "fa": "شما اجازه دسترسی به این اطلاعات را ندارید",
        "en": "You are not allowed to access this resource"
    },
    "source_application_entity": {
        "fa": "دستگاه فرستنده تصاویر",
        "en": "Source application entity"
    },
    "donot_show_again": {
        "fa": "دیگر نمایش نده",
        "en": "Do not show it again"
    },
    "first_values": {
        "fa": "مقادیر اولیه",
        "en": "First values"
    },
    "new_values": {
        "fa": "مقادیر جدید",
        "en": "New values"
    },
    "changes": {
        "fa": "تغییرات",
        "en": "Changes"
    },
    "whats_new_in_update": {
        "fa": "ویژگی‌های جدید به روز رسانی اخیر",
        "en": "What's new in this new update"
    },
    "update": {
        "fa": "به روزرسانی",
        "en": "Update"
    },
    "national_code": {
        "fa": "شماره ملی",
        "en": "National Code"
    },
    "admitted_status": {
        "fa": "وضعیت پذیرش",
        "en": "Admitted Status"
    },
    "unknown": {
        "fa": "نامشخص",
        "en": "Unknow"
    },
    "not_admitted": {
        "fa": "پذیرش نشده",
        "en": "Not admitted"
    },
    "structure_report_hovered": {
        "fa": "توضیحات مختصری در مورد این گزارش ساختاریافته",
        "en": "Brief view to creators for this report creators"
    },
    "structure_report_title": {
        "fa": "سازنده‌ها و توضیحات گزارش",
        "en": "who are creators of this report"
    },
    "identifier": {
        "fa": "شناسه",
        "en": "Identifier"
    },
    "publisher": {
        "fa": "انتشار دهنده",
        "en": "Publisher"
    },
    "rights": {
        "fa": "قوانین",
        "en": "Rights"
    },
    "license": {
        "fa": "مجوز",
        "en": "License"
    },
    "creator": {
        "fa": "ایجاد کننده",
        "en": "Creator"
    },
    "contributor": {
        "fa": "مشارکت کننده",
        "en": "Contributor"
    },
    "report_changes": {
        "fa": "تغییرات گزارش",
        "en": "Report Changes"
    },
    "changes_history": {
        "fa": "تاریخچه تغییرات",
        "en": "Changes History"
    },
    "guidance": {
        "fa": "راهنما",
        "en": "Guidance"
    },
    "removed_items": {
        "fa": "موارد حذف شده",
        "en": "Removed items"
    },
    "added_items": {
        "fa": "موارد اضافه شده",
        "en": "Added Items"
    },
    "resident": {
        "fa": "رزیدنت",
        "en": "Resident"
    },
    "admin": {
        "fa": "ادمین",
        "en": "Admin"
    },
    "last_succeed_login_time": {
        "fa": "آخرین ورود موفقبت‌آمیز کاربر در {time} با آی‌پی {ip}",
        "en": "Last succeed login was at {time} with IP address {ip}"
    },
    "last_failed_login_time": {
        "fa": "آخرین تلاش ناموفق کاربر در {time} با آی‌پی {ip}",
        "en": "Last failed try to login was at {time} with IP address {ip}"
    },
    "login_status": {
        "fa": "وضعیت ورود",
        "en": "Login Status"
    },
    "login_succeed": {
        "fa": "ورود موفقیت آمیز",
        "en": "Login Succeed"
    },
    "login_failed": {
        "fa": "ورود ناموفق",
        "en": "Login Failed"
    },
    "ip": {
        "fa": "آی‌پی",
        "en": "IP"
    },
    "no_recent_session_info": {
        "fa": "اطلاعاتی در مورد ورود اخیر کاربر وجود ندارد",
        "en": "There is not any information about user last session details"
    },
    "more_sessions": {
        "fa": "نشست‌های بیشتر",
        "en": "More Sessions"
    },
    "recent_sessions": {
        "fa": "نشست‌های اخیر",
        "en": "Recent Sessions"
    },
    "NoResultFound": {
        "fa": "اطلاعات درخواستی وجود ندارد",
        "en": "No Result is found"
    },
    "spell_check": {
        "fa": "بررسی املایی",
        "en": "Spell Check"
    },
    "spell_check_modal_title": {
        "fa": "بررسی املایی و پیشنهادات تغییر",
        "en": "Spell Check and suggestion to change"
    },
    "back": {
        "fa": "عقب",
        "en": "Back"
    },
    "no_suggestion_alert": {
        "fa": "هیچ پیشنهادی برای متن شما وجود ندارد",
        "en": "There is no suggestion for your text"
    },
    "preview": {
        "fa": "پیش‌نمایش",
        "en": "Preview"
    },
    "word": {
        "fa": "کلمه",
        "en": "Word"
    },
    "usages": {
        "fa": "به‌کار رفته",
        "en": "Usages"
    },
    "suggestions": {
        "fa": "پیشنهادات",
        "en": "Suggestions"
    },
    "apply_and_exit": {
        "fa": "تایید و خروج",
        "en": "Apply & Exit"
    },
    "apply": {
        "fa": "اعمال",
        "en": "Apply"
    },
    "you_are_not_allowed_edit_another_template": {
        "fa": "شما مجاز به ویرایش این الگو نیستید",
        "en": "you are not allowed to edit this template"
    },
    "session_was_terminated": {
        "fa": "جلسه کاری خاتمه یافت",
        "en": "Session is terminated"
    },
    "current_session": {
        "fa": "نشست کنونی",
        "en": "Current session"
    },
    "session_termination_type_expired": {
        "fa": "منقضی شده",
        "en": "Expired"
    },
    "session_termination_type_logoff": {
        "fa": "خارج شده",
        "en": "Logoff"
    },
    "logoff_done": {
        "fa": "شما از سیستم خارج شدید.",
        "en": "You have been logged off."
    },
    "session_termination_type_inactive": {
        "fa": "به مدت طولانی غیرفعال بوده",
        "en": "Idle for long time"
    },
    "session_termination_type_user_self": {
        "fa": "توسط خود کاربر خاتمه یافته",
        "en": "Terminated by user self"
    },
    "session_termination_type_admin": {
        "fa": "توسط ادمین خاتمه یافته",
        "en": "Terminated by admin"
    },
    "session_termination_type_new_login": {
        "fa": "لاگین جدید بیش از حد مجاز",
        "en": "New login more than max allowed"
    },
    "session_was_not_terminated": {
        "fa": "جلسه کاری خاتمه نیافت",
        "en": "Session was not terminated"
    },
    "close_session": {
        "fa": "بستن نشست",
        "en": "close session"
    },
    "session_fail_type_incorrect_password": {
        "fa": "رمز عبور نادرست",
        "en": "Incorrect password"
    },
    "session_fail_type_insufficient_access": {
        "fa": "دسترسی ناکافی",
        "en": "Insufficient access"
    },
    "session_fail_type_user_inactive": {
        "fa": "کاربر غیرفعال شده",
        "en": "User is disabled"
    },
    "session_fail_type_too_many_sessions": {
        "fa": "تعداد جلسه کاری بیش از حد مجاز",
        "en": "Too many sessions"
    },
    "session_fail_type_ip_blocked": {
        "fa": "آی پی مسدود شده",
        "en": "IP blocked"
    },
    "barcode_scan": {
        "fa": "اسکن بارکد",
        "en": "Barcode Scan"
    },
    "barcode_not_found": {
        "fa": "!بارکدی در تصویر پیدا نشد",
        "en": "barcode not found!"
    },
    "file_size_limit_exceeded": {
        "fa": "حجم فایل بیش از حد مجاز است، حداکثر حجم مجاز {size} می‌باشد.",
        "en": "File size limit exceeded, maximum size is {size}."
    },
    "confirm": {
        "fa": "متوجه شدم",
        "en": "Confirm"
    },
    "otp": {
        "fa": "یکبار رمز",
        "en": "OTP"
    },
    "otp_explanation": {
        "fa": "برای امنیت بیشتر شما در خارج از بیمارستان رمز یکبار مصرف (otp) فعال شده که کافی است با یکی از اپلیکیشن های احراز هویت از جمله Microsoft authenticator یا Google authenticator با اسکن بارکد زیر پکس را اضافه و سپس با استفاده از عددی که نرم‌افزار در اختیار شما قرار میدهد وارد برنامه شوید.",
        "en": "Use below QR-Code in some Authenticator app like Google authenticator or Microsoft authenticator to login outside of hospital."
    },
    "otp_verification_explanation": {
        "fa": "برای حصول اطمینان نسبت به موفق بودن افزودن QR-Code در نرم افزارهای احراز هویت، عددی که این برنامه در اختیار شما قرار میدهد را در کادر زیر وارد و سپس دکمه بررسی را بزنید.",
        "en": "Try to ensure that above steps successfully done, enter an OTP below and press Check."
    },
    "otp_verification": {
        "fa": "اعتبار سنجی یکبار رمز",
        "en": "Otp Verification"
    },
    "check": {
        "fa": "بررسی",
        "en": "Check"
    },
    "otp_sign_in_info": {
        "fa": "برای ورود خارج از بیمارستان نیاز به رمز یکبار مصرف دارید. برای این موضوع باید در محل بیمارستان لاگین کرده و از قسمت منوی کاربر سپس پروفایل و در انتها منوی یکبار رمز. این منو یک کد QR قابل اسکن در اختیار شما قرار داده که با استفاده در نرم افزارهای احراز هویت عددی را در اختیار شما قرار میدهند که با وارد کردن آن در اینجا میتوانید وارد شوید",
        "en": "You have to login in hospital and from users menu then profile then OTP, gives you a QR code that could scan with Google Authenticator to have OTP for login here"
    },
    "session_fail_type_None": {
        "fa": "session_fail_type_None",
        "en": "session fail type None"
    },
    "missing_otp": {
        "fa": "پسورد یک بار مصرف (OTP) وارد نشده است. برای دسترسی از خارج مرکز لازم است با نرم افزار Google authenticator رمز یکبار مصرف را وارد کنید",
        "en": "For access from outside of center you have to set OTP by using the Google authenticator app in addition to the username and password"
    },
    "incorrect_otp": {
        "fa": "پسورد یک بار مصرف (OTP) اشتباه است",
        "en": "Incorrect one time password (OTP)"
    },
    "correct_otp": {
        "fa": "پسورد یک بار مصرف (OTP) صحیح می‌باشد",
        "en": "The one time password (OTP) is correct"
    },
    "comm": {
        "fa": "comm",
        "en": "comm"
    },
    "_url": {
        "fa": "_url",
        "en": " url"
    },
    "_url,": {
        "fa": "_url,",
        "en": " url,"
    },
    "last_time_action": {
        "fa": "آخرین دفعه {action} در: {date} - {time}",
        "en": "last time {action} was at: {date} - {time}"
    },
    "no_camera_found": {
        "fa": "متاسفانه هیچ دوربینی شناسایی نشد!",
        "en": "Sorry, no camera found!"
    },
    "dicom_available_ifonlyif": {
        "fa": "انتخاب ویور زمانی مقدور است که فرمت دایکام انتخاب شده باشد.",
        "en": "Dicom viewer available only for DICOM file formats."
    },
    "performing_physicians_name": {
        "fa": "پزشک انجام دهنده",
        "en": "performing physicians name"
    },
    "http_verb": {
        "fa": "http_verb",
        "en": "http verb"
    },
    "choose_ai_model": {
        "fa": "انتخاب مدل هوش مصنوعی",
        "en": "Choose AI model"
    },
    "send_report_ai": {
        "fa": "ارسال گزارش همراه با سوال به هوش مصنوعی",
        "en": "send report with question"
    },
    "send_report_ai_hint": {
        "fa": "با انتخاب این گزینه گزارش ثبت شده فعلی همراه با سوال شما برای هوش مصنوعی ارسال میشود",
        "en": "by enabling this, your current report also send with your question to AI model"
    },
    "choose_pictures": {
        "fa": "انتخاب تصاویر",
        "en": "Choose pictures"
    },
    "send": {
        "fa": "ارسال",
        "en": "send"
    },
    "ask_ai_title": {
        "fa": "از هوش مصنوعی بپرس ...؟",
        "en": "Ask AI ...?"
    },
    "ai": {
        "fa": "هوش مصنوعی",
        "en": "AI"
    },
    "ask_ai_question_placeholder": {
        "fa": "سوال خود را از مدل هوش مصنوعی وارد کنید ...",
        "en": "type your question here to ask AI ..."
    },
    "each_question_price": {
        "fa": "با انتخاب این مدل هزینه هر سوال شما {price} می باشد.",
        "en": "by choosing this AI model each question will cost about {price}"
    },
    "remain_credit": {
        "fa": "اعتبار باقیمانده",
        "en": "remained credit"
    },
    "rial": {
        "fa": "ریال",
        "en": "Rial"
    },
    "toman": {
        "fa": "تومان",
        "en": "Toman"
    },
    "your_not_allowed_to_download_this_resource": {
        "fa": "شما مجاز به دانلود این فایل نیستید",
        "en": "You are not allowed to download this resource"
    },
    "receiver_large_queue_size": {
        "fa": "تعداد {receiver.remain_operations} فایل در صف دریافت کننده {receiver.name} قرار دارد",
        "en": "There are {receiver.remain_operations} files in the queue of the receiver {receiver.name}"
    }
};

export default lng;